import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CARD_PRETTY_STATUS, STYLES, TEXTS, IDS } from '../constants';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';

const { TRACKER_ACTIONS } = STYLES;

const { TRACKER_ACTIONS: TRACKER_ACTIONS_TEXTS } = TEXTS;

const {
  TRACKER_ACTIONS: { CTA_1, CTA_2 },
} = IDS;

interface IStepActions {
  title: string;
  styles: string;
  linkUrl: string;
}

interface IProps {
  activeStepActions: IStepActions[] | [];
  activeStep: number;
}
export const TrackerActions = ({ activeStepActions, activeStep }: IProps) => {
  const navigate = useNavigate();
  const handleRedirectAction = (idx: number) => {
    navigate(`/${activeStepActions[idx].linkUrl}`);
  };
  const { t } = useTranslation();

  return (
    <div className={TRACKER_ACTIONS.CONTAINER}>
      {activeStep === CARD_PRETTY_STATUS.SHIPPING && (
        <div className={TRACKER_ACTIONS.SHIPPING.CONTAINER}>
          <Heading title={t(TRACKER_ACTIONS_TEXTS.SHIPPING.HEADING)} className={TRACKER_ACTIONS.SHIPPING.HEADING} />
          <Button
            onClick={() => navigate('/activate-card?fromTracker=true')}
            className={activeStepActions?.[0]?.styles}
            id={CTA_1}
            // @ts-ignore
            title={t(activeStepActions[0]?.title)}
          />
        </div>
      )}
      {activeStep === CARD_PRETTY_STATUS.ACTIVATION_REQUIRED && (
        <div className={TRACKER_ACTIONS.ACTIVATION_REQUIRED.CONTAINER}>
          <Button
            onClick={() => navigate('/activate-card?fromTracker=true')}
            className={activeStepActions?.[0]?.styles}
            id={CTA_1}
            // @ts-ignore
            title={t(activeStepActions?.[0]?.title)}
          />
          <Button
            onClick={() => window.open('mailto:support@lili.co?subject=My Lili card', '_blank')}
            className={activeStepActions?.[1]?.styles}
            id={CTA_2}
            // @ts-ignore
            title={t(activeStepActions?.[1]?.title)}
          />
        </div>
      )}
      {activeStep === CARD_PRETTY_STATUS.NEEDS_FUND && (
        <div className={TRACKER_ACTIONS.NEEDS_FUND.CONTAINER}>
          <Button
            onClick={() => handleRedirectAction(0)}
            className={activeStepActions?.[0]?.styles}
            id={CTA_1}
            // @ts-ignore
            title={t(activeStepActions?.[0]?.title)}
          />
        </div>
      )}
    </div>
  );
};
